import * as React from 'react';

import Environment from './Environment';

const Utility = {
  generateId: (l: number = 32) => {
    // 生成する文字列の長さ

    // 生成する文字列に含める文字セット
    const c = 'abcdefghijklmnopqrstuvwxyz0123456789';

    const cl = c.length;
    let r = '';
    for (let i = 0; i < l; i++) {
      r += c[Math.floor(Math.random() * cl)];
    }
    return r;
  },

  maskIdentity: (identity: string) => {
    return identity.slice(0, 2) + '*'.repeat(identity.length - 2);
  },

  CommonBackground(): string {
    return Environment.iPhone() ? 'IphoneBackground' : 'AndroidBackground';
  },

  dateFormat: (date: Date, format: string): string => {
    const fmt = {
      yyyy: (d: Date) => {
        return d.getFullYear() + '';
      },
      yy: (d: Date) => {
        return (d.getFullYear() + '').slice(-2);
      },

      MM: (d: Date) => {
        return ('0' + (d.getMonth() + 1)).slice(-2);
      },
      M: (d: Date) => {
        return d.getMonth() + 1;
      },

      dd: (d: Date) => {
        return ('0' + d.getDate()).slice(-2);
      },
      d: (d: Date) => {
        return d.getDate();
      },

      hh: (d: Date) => {
        return ('0' + d.getHours()).slice(-2);
      },
      mm: (d: Date) => {
        return ('0' + d.getMinutes()).slice(-2);
      },
      ss: (d: Date) => {
        return ('0' + d.getSeconds()).slice(-2);
      }
    };
    const priority: string[] = [
      'yyyy',
      'yy',
      'MM',
      'M',
      'dd',
      'd',
      'hh',
      'mm',
      'ss'
    ];

    return priority.reduce((res, f) => res.replace(f, fmt[f](date)), format);
  },

  extractTags(text: string): string[] {
    const result = text.match(/(\#|＃).*?(\s+|#|＃|$)/g);
    let tags: string[] = [];
    if (result !== null) {
      tags = result
        .map(tag =>
          tag
            .replace(/#/g, '')
            .replace(/＃/g, '')
            .trim()
        )
        .filter(tag => tag !== '');
    }
    return Array.from(new Set(tags));
  },
  nl2br: (text: string) => {
    const regex = /(\n)/g;
    return text.split(regex).map(line => {
      if (line.match(regex)) {
        return React.createElement('br');
      } else {
        return line;
      }
    });
  }
};

export default Utility;



// WEBPACK FOOTER //
// ./src/common/Utility.ts